import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import App from "./App";
import AppThemeProvider from "./AppThemeProvider"; // Import the configured Redux store
import { PostHogProvider } from "posthog-js/react";
import store from "./store/store";
import "./index.css";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

const posthogKey = process.env.REACT_APP_PUBLIC_POSTHOG_KEY;
const posthogHost = process.env.REACT_APP_PUBLIC_POSTHOG_HOST;

const options = posthogHost ? {
  api_host: posthogHost,
} : undefined;
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

// Apply fade-in animation to root element
const rootElement = document.getElementById("root");
if (rootElement) {
  rootElement.style.opacity = "0";
  rootElement.style.transition = "opacity 0.3s ease-in-out";
  
  // Trigger fade-in after a micro delay
  requestAnimationFrame(() => {
    rootElement.style.opacity = "1";
  });
}

// Cargar Stripe solo si la clave está disponible
const stripeKey = process.env.REACT_APP_STRIPE_PKEY;
const stripePromise = stripeKey && stripeKey.startsWith('pk_') 
  ? loadStripe(stripeKey, {}) 
  : null;

// Si la clave no está disponible o no es válida, mostrar una advertencia
if (!stripePromise) {
  console.warn('Stripe API key is missing or invalid. Payment features will not work correctly.');
}

const AppWithProviders = () => {
  // Componente interno con o sin Stripe
  const AppWithStripe = () => (
    stripePromise ? (
      <Elements stripe={stripePromise}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Elements>
    ) : (
      <BrowserRouter>
        <App />
      </BrowserRouter>
    )
  );

  // Renderizar con o sin PostHog
  if (posthogKey && typeof posthogKey === 'string') {
    return (
      <PostHogProvider apiKey={posthogKey} options={options}>
        <Provider store={store}>
          <AppWithStripe />
        </Provider>
      </PostHogProvider>
    );
  }

  return (
    <Provider store={store}>
      <AppWithStripe />
    </Provider>
  );
};

root.render(
  <React.StrictMode>
    <AppThemeProvider>
      <AppWithProviders />
    </AppThemeProvider>
  </React.StrictMode>,
);
